/* Spinder Design — Lookbook: toetsenbord-toegankelijke hotspot-popovers.
   Eén popover tegelijk open. Sluit met Escape of klik buiten. Plaatst de
   popover automatisch binnen beeld (links/rechts/onder flippen). */
(function () {
  'use strict';

  function initLookbook(stage) {
    var hotspots = Array.prototype.slice.call(stage.querySelectorAll('[data-hotspot]'));
    if (!hotspots.length) return;

    function closeAll(except) {
      hotspots.forEach(function (hs) {
        if (hs === except) return;
        var btn = hs.querySelector('[data-hotspot-toggle]');
        var pop = hs.querySelector('[data-hotspot-popover]');
        if (!btn || !pop) return;
        hs.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        pop.hidden = true;
        pop.classList.remove('is-left', 'is-right', 'is-below');
      });
    }

    function position(pop) {
      pop.classList.remove('is-left', 'is-right', 'is-below');
      // Meet en corrigeer tegen de viewport-randen.
      var rect = pop.getBoundingClientRect();
      var vw = document.documentElement.clientWidth;
      if (rect.right > vw - 8) pop.classList.add('is-right');
      else if (rect.left < 8) pop.classList.add('is-left');
      if (rect.top < 8) pop.classList.add('is-below');
    }

    hotspots.forEach(function (hs) {
      var btn = hs.querySelector('[data-hotspot-toggle]');
      var pop = hs.querySelector('[data-hotspot-popover]');
      if (!btn || !pop) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        closeAll(isOpen ? null : hs);
        if (isOpen) {
          hs.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          pop.hidden = true;
        } else {
          hs.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          pop.hidden = false;
          window.requestAnimationFrame(function () { position(pop); });
        }
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeAll(); btn.focus(); }
      });
      pop.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeAll(); btn.focus(); }
      });
    });

    // Klik buiten een hotspot sluit alles.
    document.addEventListener('click', function (e) {
      if (!stage.contains(e.target)) { closeAll(); return; }
      var inside = e.target.closest ? e.target.closest('[data-hotspot]') : null;
      if (!inside) closeAll();
    });
  }

  function init() {
    var stages = document.querySelectorAll('[data-lookbook]');
    for (var i = 0; i < stages.length; i++) initLookbook(stages[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var stage = e.target.querySelector('[data-lookbook]');
    if (stage) initLookbook(stage);
  });
})();
